export enum PageLimit {
  min = 10,
  medium = 50,
  max = 100
}
